<script>
import BaseContainer from "./BaseContainer.vue";
export default {
  extends: BaseContainer,
  data() {
    return {
      position: "side",
      allow: ["image", "video", "text"]
    };
  }
};
</script>
